<div class="app-content">
  <div class="image-container">
    <img src="/assets/progress-tracker.png" alt="Progress Tracker image" />
  </div>
</div>
